<div class="load-indicator-container" *ngIf="loading; else loaded">
  <p>{{ translation?.loading }}</p>
  <abc-load-indicator></abc-load-indicator>
</div>

<ng-template #loaded>
  <pre *ngIf="executed && !resultsEmpty; else inform"><code #code></code></pre>
  <ng-template #inform
    ><div class="message-container" *ngIf="resultsEmpty || !data">
      <p *ngIf="!loading">
        {{ translation?.resultMessage.clickMessage }} '{{ translation?.resultMessage.button }}'
        <span class="dx-icon dx-icon-variable"></span>{{ translation?.resultMessage.viewMessage }}
      </p>
    </div></ng-template
  >
</ng-template>
